<template>
 <Instructions></Instructions>
</template>

<script>
import Instructions from '@/components/information/Instructions/Index'
export default {
  components: {
    Instructions
  }
}
</script>

<style scoped>

</style>
